import { useParams } from "react-router-dom";
import "../../../i18n/i18n";

export const LinkyConnectionsTab = () => {
  const params = useParams();

  if (params.tab !== "linky_connections") {
    return null;
  }

  return <></>;
};
